function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError, loginObj } from '@/services/base';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['help_center']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8090')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = 'Bearer ' + window.userInfo.accessToken;
  return config;
};

//appApisGTW.before(beforeMiddleware)
setupInterceptors(appApisGTW);
var CONTROLLER_NAME = "/help_center";
var QUESTIONS = "/questions";
var VIDEOS = "/videos";
var SUGERENCES = "/sugerences";
var RESPONSABLES = "/responsables";
var NEWS = "/news";
export default {
  getQuestions: function getQuestions(data) {
    var _this = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + QUESTIONS + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this.getQuestions(data);
      });
    });
  },
  createQuestion: function createQuestion(data) {
    var _this2 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + QUESTIONS + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this2.createQuestion(data);
      });
    });
  },
  updateQuestion: function updateQuestion(data) {
    var _this3 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + QUESTIONS + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this3.updateQuestion(data);
      });
    });
  },
  deleteQuestion: function deleteQuestion(data) {
    var _this4 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + QUESTIONS + '/delete', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this4.deleteQuestion(data);
      });
    });
  },
  getVideos: function getVideos(data) {
    var _this5 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + VIDEOS + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this5.getVideos(data);
      });
    });
  },
  getVideobyID: function getVideobyID(data) {
    var _this6 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + VIDEOS + '/get', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this6.getVideobyID(data);
      });
    });
  },
  createVideo: function createVideo(data) {
    var _this7 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + VIDEOS + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this7.createVideo(data);
      });
    });
  },
  updateVideo: function updateVideo(data) {
    var _this8 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + VIDEOS + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this8.updateVideo(data);
      });
    });
  },
  deleteVideo: function deleteVideo(data) {
    var _this9 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + VIDEOS + '/delete', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this9.deleteVideo(data);
      });
    });
  },
  getSugerences: function getSugerences(data) {
    var _this0 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + SUGERENCES + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this0.getSugerences(data);
      });
    });
  },
  createSugerence: function createSugerence(data) {
    var _this1 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + SUGERENCES + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this1.createSugerence(data);
      });
    });
  },
  deleteSugerence: function deleteSugerence(data) {
    var _this10 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + SUGERENCES + '/delete', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this10.deleteSugerence(data);
      });
    });
  },
  getResponsables: function getResponsables(data) {
    var _this11 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + RESPONSABLES + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this11.getResponsables(data);
      });
    });
  },
  createResponsable: function createResponsable(data) {
    var _this12 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + RESPONSABLES + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this12.createResponsable(data);
      });
    });
  },
  getNews: function getNews(data) {
    var _this13 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + NEWS + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this13.getNews(data);
      });
    });
  },
  createNew: function createNew(data) {
    var _this14 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + NEWS + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this14.createNew(data);
      });
    });
  },
  updateNew: function updateNew(data) {
    var _this15 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + NEWS + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this15.updateNew(data);
      });
    });
  },
  deleteNew: function deleteNew(data) {
    var _this16 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + NEWS + '/delete', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this16.deleteNew(data);
      });
    });
  }
};